import React from 'react';
import { User, ItemList } from 'v2/models';
import { useMultiSelectUserOptions } from 'v2/hooks/useMultiSelectUserOptions';
import MultiFilterDropdown from '../MultiFilterDropdown';
import { CurrentStateFilterContext } from 'v2/context/currentStateFilterContext';

export interface namedUser extends User {
  name: string;
}

interface MultiSelectUserProps {
  onChange: (option: ItemList) => void;
}

export const MultiSelectUser = ({ onChange }: MultiSelectUserProps) => {
  const { defaultOptions, loadOptions, currentState, setCurrentState } =
    useMultiSelectUserOptions();

  return (
    <CurrentStateFilterContext.Provider
      value={{
        setCurrentState,
        currentState,
      }}
    >
      <MultiFilterDropdown
        id="allUsers"
        placeHolder="All users selected"
        secondaryPlaceHolder="Select users"
        defaultOptions={defaultOptions}
        loadOptions={loadOptions}
        onChange={onChange}
      />
    </CurrentStateFilterContext.Provider>
  );
};
